// extracted by mini-css-extract-plugin
module.exports = {"servicesContainer":"ServiceListItem_servicesContainer__coeOv","service":"ServiceListItem_service__D2hu8","serviceLink":"ServiceListItem_serviceLink__SpwF0"};